module.exports = __webpack_public_path__ + "static/media/PDF.97c9916f.svg";